import ButtonsWrapper from './ButtonsWrapper';
import PillButton from './PillButton';

const PillButtons = {
  Wrapper: ButtonsWrapper,
  Button: PillButton
};

export default PillButtons;
